export default __webpack_public_path__ + "static/media/JTAN_07_mos.3868a7f4.wav";